import { cn, getBackgroundClass } from '@workspace/lib';
import { CustomPortableText } from '@workspace/ui/PortableText';

import type { ImageTextBlockProps } from './image-text-block.types';
import { ImageTextMedia } from './ImageTextMedia.ui';

export function ImageTextBlock({ block }: ImageTextBlockProps) {
  if (!block || typeof block !== 'object') return null;
  const { imagePosition = false, image, body, backgroundColor, isVideo, video } = block;

  const backgroundClass = getBackgroundClass(backgroundColor);
  const textColorClass = backgroundClass === 'bg-primary' ? '[&_*]:text-white!' : '';

  return (
    <div className={cn('image-text-block-bg w-full', backgroundClass)}>
      <div className="porta-container">
        <section className="py-12 px-6 md:py-3xl md:px-4xl">
          <div
            className={cn(
              'flex flex-col md:flex-row items-center gap-8',
              imagePosition ? 'md:flex-row-reverse md:gap-3xl justify-between' : 'md:gap-3xl md:justify-between',
            )}
          >
            {/* Text Content */}
            <div className="w-full min-w-0">
              <div className="space-y-4">
                {body?.length > 0 && (
                  <CustomPortableText value={body} className={cn('prose max-w-none', textColorClass)} />
                )}
              </div>
            </div>

            {/* Media */}
            <div className={cn('max-sm:w-full', imagePosition ? 'md:order-1' : 'md:order-2')}>
              <div
                className={cn(
                  'w-full h-81.75 md:w-136 md:h-136 md:mx-auto flex items-center justify-center',
                  isVideo ? 'bg-transparent' : 'bg-light-silver',
                )}
              >
                <ImageTextMedia isVideo={isVideo} video={video} image={image} imagePosition={imagePosition} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
